<ng-container rtBlock="sc-page-header">
    <div rtElem="inner">
        <div rtElem="bar">
            <sc-breadcrumbs [items]="parentCrumbs()" />
            <span rtElem="current">{{ currentLabel() }}</span>
        </div>

        <div rtElem="headline">
            <ng-content select="[slot=title]" />
        </div>

        <div rtElem="lead">
            <ng-content select="[slot=lead]" />
        </div>

        <div rtElem="filters">
            <ng-content select="[slot=filters]" />
        </div>
    </div>
</ng-container>
